import {ArchiveRecord} from 'archive/ArchiveConstants';

import {RequestSchema} from '../RequestConstants';

export enum RequestSchemaActionType {
  REQUEST_SCHEMAS_LISTED = 'REQUEST_SCHEMAS_LISTED',
  REQUEST_SCHEMA_FETCHED = 'REQUEST_SCHEMA_FETCHED',
  REQUEST_SCHEMAS_ARCHIVED = 'REQUEST_SCHEMAS_ARCHIVED',
  REQUEST_SCHEMAS_UNARCHIVED = 'REQUEST_SCHEMAS_UNARCHIVED',
  REQUEST_SCHEMAS_UPDATED_FROM_GQL = 'REQUEST_SCHEMAS_UPDATED_FROM_GQL',
}

interface RequestSchemasListedAction {
  type: RequestSchemaActionType.REQUEST_SCHEMAS_LISTED;
  requestSchemasById: {[schemaId: string]: RequestSchema};
}

export function requestSchemasListed(requestSchemasById: {
  [schemaId: string]: RequestSchema;
}): RequestSchemasListedAction {
  return {
    type: RequestSchemaActionType.REQUEST_SCHEMAS_LISTED,
    requestSchemasById,
  };
}

interface RequestSchemaFetchedAction {
  type: RequestSchemaActionType.REQUEST_SCHEMA_FETCHED;
  requestSchema: RequestSchema;
}

export function requestSchemaFetched(requestSchema: RequestSchema): RequestSchemaFetchedAction {
  return {
    type: RequestSchemaActionType.REQUEST_SCHEMA_FETCHED,
    requestSchema,
  };
}

interface RequestSchemasUpdatedFromGQLAction {
  type: RequestSchemaActionType.REQUEST_SCHEMAS_UPDATED_FROM_GQL;
  requestSchemasById: {[schemaId: string]: RequestSchema};
}

export function requestSchemasUpdatedFromGQL(requestSchemasById: {
  [schemaId: string]: RequestSchema;
}): RequestSchemasUpdatedFromGQLAction {
  return {
    type: RequestSchemaActionType.REQUEST_SCHEMAS_UPDATED_FROM_GQL,
    requestSchemasById,
  };
}

interface RequestSchemasArchivedAction {
  type: RequestSchemaActionType.REQUEST_SCHEMAS_ARCHIVED;
  itemIds: Array<string>;
  archiveRecordsByItemId: {
    [schemaId: string]: ArchiveRecord;
  };
}

export function requestSchemasArchived(
  itemIds: Array<string>,
  archiveRecordsByItemId: {[itemId: string]: ArchiveRecord}
): RequestSchemasArchivedAction {
  return {
    type: RequestSchemaActionType.REQUEST_SCHEMAS_ARCHIVED,
    itemIds,
    archiveRecordsByItemId,
  };
}

interface RequestSchemasUnarchivedAction {
  type: RequestSchemaActionType.REQUEST_SCHEMAS_UNARCHIVED;
  itemIds: Array<string>;
}

export function requestSchemasUnarchived(itemIds: Array<string>): RequestSchemasUnarchivedAction {
  return {
    type: RequestSchemaActionType.REQUEST_SCHEMAS_UNARCHIVED,
    itemIds,
  };
}

export type RequestSchemaAction =
  | RequestSchemasListedAction
  | RequestSchemaFetchedAction
  | RequestSchemasArchivedAction
  | RequestSchemasUnarchivedAction
  | RequestSchemasUpdatedFromGQLAction;
